import { takeEvery } from 'typed-redux-saga';
import { actionDietDiariesReportLoadData } from './actions';
import { workerErrorNotifyThunk } from 'utils/sagas';

export const dietDiariesReportSagas = [
  takeEvery(actionDietDiariesReportLoadData.rejected, workerErrorNotifyThunk),
];
